'use client';

import { getFragmentData } from '@/__generated__';
import { ENTRY_BASE_FRAGMENT } from '@/gql/fragments/entries.gql';
import useScrollPosition from '@/lib/utils/useScrollPosition';
import { useBreakpointMin } from '@/theme';
import Animation from '../Animation';
import Logo from '../Logo';
import Box from '../ui/Box';
import { useNavBar } from './useNavBar';

export default function NavLogo() {
  const { page } = useNavBar();
  const pos = useScrollPosition();
  const md = useBreakpointMin('md');

  const base = getFragmentData(ENTRY_BASE_FRAGMENT, page);
  const eventUri = base?.sectionHandle === 'event';

  return (
    <Box cx={{ pB: { xs: '2xs', md: 'md' }, pT: { xs: '2xs', md: 'none' } }}>
      {md ? (
        <Animation />
      ) : (
        <Logo
          homeLink
          style={{
            width: 'auto',
            maxWidth: '75%',
            color: pos < 10 && eventUri ? 'white' : 'inherit',
          }}
        />
      )}
    </Box>
  );
}
